// notification.service.ts
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { interval, forkJoin } from 'rxjs';
import { RsbService } from 'src/app/service/rsb.service';
@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private events: any[] = [];

  constructor(private snackBar: ToastrService, private rsbService: RsbService) {}

  // set events from calendar component
  setEvents(events: any[]) {
    this.events = events;
  }

  // start monitoring continuously
  startChecking() {
    interval(60000).subscribe(() => {  // every 1 min
      this.checkNotifications();
    });
  }

  private checkNotifications() {
    const now = new Date();

    this.events.forEach(event => {
      const eventDate = new Date(event.start);
      const diff = this.daysDiff(now, eventDate);
      if (diff === 1) {
        this.showToast(`Reminder: "${event.title}" is tomorrow at ${eventDate.toLocaleTimeString()}`);
      } else if (diff === 0 && eventDate > now) {
        this.showToast(`Reminder: "${event.title}" is today at ${eventDate.toLocaleTimeString()}`);
      }
    });
  }

  private daysDiff(date1: Date, date2: Date): number {
    const d1 = new Date(date1.toDateString());
    const d2 = new Date(date2.toDateString());
    return Math.floor((d2.getTime() - d1.getTime()) / (1000 * 60 * 60 * 24));
  }

  private showToast(message: string) {
    this.snackBar.info(message);
  }

    getCalendarData(date?: string): void {
      forkJoin({
        followups: this.rsbService.getCalanderFollowup(),
        opportunities: this.rsbService.getOppCalanderFollowup()
      }).subscribe(({ followups, opportunities }) => {
        this.events = [];
  
        // ✅ process followup events
        if (followups.statusCode === 0 && followups.contents.length) {
          const followupEvents = followups.contents.map((record: any, index: number) => {
            const start = new Date(record.date);
            return {
              id: record.leadId || 'F-' + index,
              title: 'Follow Up - ' + record.customerName,
              start: start.toISOString(),
              extendedProps: {
                mobile: record.mobile,
                email: record.email,
                staff: record.staffId,
                remarks: record.description,
                property: record.propertyTitle,
                productValue: record.price,
                name: record.customerName,
                source: 'followup'
              }
            };
          });
          this.events = [...this.events, ...followupEvents];
        }
  
        // ✅ process opportunity events
        if (opportunities.statusCode === 0 && opportunities.contents.length) {
          const oppEvents = opportunities.contents.map((record: any, index: number) => {
            const start = new Date(record.date);
            return {
              id: record.leadId || 'O-' + index,
              title: 'Opportunity - ' + record.customerName,
              start: start.toISOString(),
              extendedProps: {
                mobile: record.mobile,
                email: record.email,
                staff: record.staffId,
                remarks: record.remarks,
                property: record.propertyTitle,
                productValue: record.price,
                name: record.customerName,
                source: 'opportunity'
              }
            };
          });
          this.events = [...this.events, ...oppEvents];
        }
        this.startChecking()
      });
  
    }
  
}
